<template>
  <form @submit.prevent="handleSubmit">
    <table class="table table-striped m-0">
      <thead>
      <tr>
        <th></th>
        <th>Modulname</th>
        <th style="text-align: right">Einheiten</th>
        <th style="text-align: right">Bestellnummer</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="module in privateCoachingModules" :key="module.id">
        <td>
          <label class="custom-checkbox position-relative">
            <input type="checkbox"
                   v-model="selectedModuleIds"
                   :value="module.id"
                   class="custom-checkbox position-absolute"/>
            <div class="custom-check-icon"></div>
          </label>
        </td>
        <td>
          <strong class="js-lists-values-employee-name">
            {{ module.name }}
          </strong>
        </td>
        <td style="text-align: right;">
          <strong class="js-lists-values-employee-name">
            {{ module.units }}
          </strong>
        </td>
        <td style="text-align: right;">
          <strong class="js-lists-values-employee-name">
            {{ module.orderNumber }}
          </strong>
        </td>
      </tr>
      </tbody>
    </table>
    <input type="hidden" :value="privateCoachingId" name="privateCoachingId"/>

    <div class="mt-5 me-1 text-center">
      <button type="submit" class="btn btn-primary">Genehmigen</button>
    </div>
  </form>
</template>

<script setup>
import privateCoachingService from '@/api/Unemployed/PrivateCoaching';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import { defineEmits, defineProps, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const isLoaded               = ref(false);
const isSubmitting           = ref(false);
const privateCoachingModules = ref([]);
const selectedModuleIds      = ref([]);
const emit                   = defineEmits([ 'update:modelValue', 'update:submitForm' ]);

const props = defineProps({
  unemployedId: {
    type: Number,
    required: true,
  },
  privateCoachingId: {
    type: Number,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

async function handleSubmit() {
  try {
    if (isSubmitting.value) return;
    isSubmitting.value = true;

    await privateCoachingService.approveModules(selectedModuleIds.value, props.privateCoachingId);

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getPrivateCoachingData(privateCoachingId) {
  try {
    CloseToast();
    const { data }               = await privateCoachingService.getPrivateCoaching(privateCoachingId);
    privateCoachingModules.value = data.data?.modules || [];

    selectedModuleIds.value = privateCoachingModules.value.filter((module) => module.isApproved)
                                                    .map((module) => module.id);
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  if (props.privateCoachingId) {
    await getPrivateCoachingData(props.privateCoachingId);
  }

  isLoaded.value = true;
});
</script>

<style scoped>
.custom-checkbox .custom-check-icon {
  position: relative;
  display: inline-block;
  width: 18px;
  min-width: 18px;
  height: 18px;
  min-height: 18px;
  border: 2px solid var(--primary);
  border-radius: 4px;
  background-color: white;
  margin-right: 8px;
}

.custom-checkbox .custom-check-icon::before {
  content: '';
  position: absolute;
  top: 1px;
  left: 4px;
  width: 6px;
  height: 11px;
  border: solid var(--primary);
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.custom-checkbox input[type="checkbox"]:checked + .custom-check-icon::before {
  opacity: 1;
}

.custom-checkbox .custom-check-icon:hover {
  border-color: var(--primary);
}
</style>